@if (done()) {
  <app-auth-window subtitle="auth.subtitle_reset_done">
    <div class="cmc-auth-result">
      <span class="cmc-auth-result__icon" aria-hidden="true"><mat-icon>check_circle</mat-icon></span>
      <p class="cmc-auth-text" role="status">{{ 'auth.reset_done_text' | translate }}</p>
    </div>
    <a class="cmc-auth-button cmc-auth-button--submit" routerLink="/auth/login">
      {{ 'auth.sign_in' | translate }}<mat-icon aria-hidden="true">arrow_forward</mat-icon>
    </a>
  </app-auth-window>
} @else {
  <app-auth-window subtitle="auth.subtitle_reset">
    <p class="cmc-auth-text">{{ 'auth.reset_text' | translate: { n: minLength } }}</p>

    @if (error(); as message) {
      <div class="cmc-auth-alert" role="alert">
        <mat-icon aria-hidden="true">error</mat-icon>
        <span>
          {{ message }}
          <a class="cmc-auth-alert__link" routerLink="/auth/forgot-password">{{ 'auth.request_new_link' | translate }}</a>
        </span>
      </div>
    }

    <form class="cmc-auth-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="cmc-auth-field" [class.is-invalid]="invalid('email')">
        <label class="cmc-auth-field__label" for="resetEmail">{{ 'auth.email' | translate }}</label>
        <div class="cmc-auth-field__control">
          <mat-icon aria-hidden="true">mail</mat-icon>
          <input id="resetEmail" type="email" formControlName="email" autocomplete="email"
            [attr.aria-invalid]="invalid('email')">
        </div>
        @if (invalid('email')) {
          <span class="cmc-auth-field__error">{{ 'auth.error_email' | translate }}</span>
        }
      </div>

      <div class="cmc-auth-field" [class.is-invalid]="invalid('password')">
        <label class="cmc-auth-field__label" for="resetPassword">{{ 'auth.new_password' | translate }}</label>
        <div class="cmc-auth-field__control">
          <mat-icon aria-hidden="true">lock</mat-icon>
          <input id="resetPassword" formControlName="password" autocomplete="new-password"
            [type]="showPassword() ? 'text' : 'password'" [attr.aria-invalid]="invalid('password')">
          <button type="button" class="cmc-auth-icon-button" (click)="showPassword.set(!showPassword())"
            [attr.aria-pressed]="showPassword()"
            [attr.aria-label]="(showPassword() ? 'auth.hide_password' : 'auth.show_password') | translate"
            [matTooltip]="(showPassword() ? 'auth.hide_password' : 'auth.show_password') | translate">
            <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
        @if (invalid('password')) {
          <span class="cmc-auth-field__error">{{ 'auth.error_password_length' | translate: { n: minLength } }}</span>
        }
      </div>

      <div class="cmc-auth-field" [class.is-invalid]="invalid('confirmation')">
        <label class="cmc-auth-field__label" for="resetConfirmation">{{ 'auth.confirm_password' | translate }}</label>
        <div class="cmc-auth-field__control">
          <mat-icon aria-hidden="true">lock</mat-icon>
          <input id="resetConfirmation" formControlName="confirmation" autocomplete="new-password"
            [type]="showPassword() ? 'text' : 'password'" [attr.aria-invalid]="invalid('confirmation')">
        </div>
        @if (invalid('confirmation')) {
          <span class="cmc-auth-field__error">{{ 'auth.error_password_match' | translate }}</span>
        }
      </div>

      <button type="submit" class="cmc-auth-button cmc-auth-button--submit" [disabled]="submitting()"
        [attr.aria-busy]="submitting()">
        {{ 'auth.save_password' | translate }}
        @if (submitting()) {
          <mat-icon aria-hidden="true">progress_activity</mat-icon>
        }
      </button>
      <a class="cmc-auth-link cmc-auth-back" routerLink="/auth/login">← {{ 'auth.back_to_login' | translate }}</a>
    </form>
  </app-auth-window>
}
